import { API_TYPES } from '@app/config';
import { HttpRequest } from './http-request';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class PreBidHttpRequest {

  constructor(
    private _httpRequest: HttpRequest
  ) { }

  /**
   * method to get the data
   *
   * @param {string} url
   * @param {HttpParams} [requestparams]
   * @param {boolean} [includeLangParam=false]
   * @returns
   * @memberof HttpRequest
   */
  public get(url: string, requestparams?: HttpParams, includeLangParam = true) {
    return this._httpRequest.get(url, requestparams, includeLangParam, API_TYPES.PREBID);
  }

  public postMultipartData(url: string, body: string, requestparams?: HttpParams, observeEvents: boolean = false, reportProgress: boolean = false, type?: API_TYPES) {
    return this._httpRequest.postMultipartData(url, body, requestparams, observeEvents, reportProgress, API_TYPES.PREBID);
  }

  /**
   * Post method used for insert data
   *
   * @param {string} url
   * @param {any} body
   * @returns
   * @memberof HttpRequest
   */

  public post(url: string, body: any, requestparams?: HttpParams) {
    return this._httpRequest.post(url, body, requestparams, API_TYPES.PREBID);
  }

  /**
   * Put method used for update data
   *
   * @param {string} url
   * @param {any} body
   * @returns
   * @memberof HttpRequest
   */
  public put(url: string, body: any) {
    return this._httpRequest.put(url, body, API_TYPES.PREBID);
  }

  /**
   * Delete method used for delete data
   *
   * @param {string} url
   * @returns
   * @memberof HttpRequest
   */
  public delete(url: string) {
    return this._httpRequest.delete(url, API_TYPES.PREBID);
  }

  /**
   * petch method used for update data
   *
   * @param {string} url
   * @param {any} body
   * @returns
   * @memberof HttpRequest
   */
  public patch(url: string, body: any) {
    return this._httpRequest.patch(url, body, API_TYPES.PREBID);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/http-client/prebid-http-request.ts